window.onload = function () {
  document
    .querySelector(".product-form__submit")
    .addEventListener("click", addToCart);
  //document.getElementById("addon_product_id").value = "41941711519814";

  addLoading();
};

// Function to add the main product and the upsell product to the cart, then open the cart drawer
async function addToCart() {
  try {
    //Generate a pair ID to identify the combination of the main product with the addon product.
    const pairId =
      document.querySelector("#main_product_id").value +
      "_" +
      Math.random().toString(9).substr(2, 9);

    document.getElementById("cust_pairId").value = pairId;

    // Get the variant IDs from the hidden inputs
    const mainProductVariantId =
      document.querySelector("#main_product_id").value;

    // Start loading animation on the "Add to Cart" button
    document.querySelector(".product-form__submit").classList.add("loading");

    //check: addon product is not added or not
    if (document.getElementById("addon_product_id").value) {
      //submit addon data
      const form = document.querySelector('[id^="product-form-template-"]');
      const formData = new FormData(form);

      const response = await fetch(form.action, {
        method: form.method,
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
    }

    // Add main product to cart using Shopify API
    const selected_qty = document.querySelector(".quantity__input").value || 1;
    await addToCartCustom(mainProductVariantId, selected_qty, { pairId });

    // Update the cart for frontend UI
    updateCart();
  } catch (error) {
    console.error("Error adding products to cart:", error);
  }
}

// Function to add a product to the cart using Shopify API
async function addToCartCustom(variantId, quantity, properties) {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: properties,
      }),
    });
    return await response.json();
  } catch (error) {
    console.error(`Error adding product (ID: ${variantId}) to cart:`, error);
    throw error;
  }
}

// Function to update the cart drawer and cart icon bubble
async function updateCart() {
  // Replace the existing cart drawer HTML with the new HTML
  const cartSidebarInstance = document.querySelector("cart-sidebar");
  cartSidebarInstance.reload();

  // Open the cart drawer
  document.querySelector(".header__icon--cart").click();

  //display bubble on the cart icon
  document.querySelector(".cart-count-bubble").innerHTML =
    "<span aria-hidden='true'></span>";

  // Hide the loader on the "Add to Cart" button
  document.querySelector(".product-form__submit").classList.remove("loading");
}

// add loading div for Add to cart button
function addLoading() {
  const button = document.querySelector(".product-form__submit");
  const template = document.getElementById("template-loading-overlay");

  if (button && template) {
    const loadingOverlay = template.content.cloneNode(true);
    button.appendChild(loadingOverlay);
  }
}
